<template>
  <div>
    <h1 v-t="'views.home.title'" class="mt-0"></h1>
  </div>
</template>

<script>
export default {
  name: 'home',
};
</script>
